<app-header-nav-widget [text]="'card_label_ajanlatok' | translate"></app-header-nav-widget>

<!-- start of datatable -->
<div class="card card-grid mt-6">
    <div class="card-header py-5 flex-wrap">
        
        <app-core-table-paginator 
        [table]="this.table" 
        [coreResponsePagination]="componentCollectionMetadata" 
        (paginationEvent)="tablePagination($event)"
        >
        </app-core-table-paginator>

    </div>
    <div class="card-body">
        <div class="scrollable-x-auto">
            <table class="table table-auto table-border">
                <thead>
                    <tr>
                        <th class="w-[120px]">
                            <span class="sort">
                                <span class="sort-label">
                                    {{ 'table_head_ajanlatszam' | translate }}
                                </span>
                            </span>
                        </th>
                        <th class="min-w-[400px]">
                            <span class="sort">
                                <span class="sort-label">
                                    {{ 'table_head_ajanlatcim' | translate }}
                                </span>
                            </span>
                        </th>
                        <th class="min-w-[100px]">
                            <span class="sort">
                                <span class="sort-label">
                                    {{ 'table_head_verziok' | translate }}
                                </span>
                            </span>
                        </th>       
                        <th class="min-w-[140px]">
                            <span class="sort" data-field="kelt" [sortSubject]="sortSubject" [sortDefaults]="_columnSort" (changed)="onSortChanged($event)" tableSortDirection>
                                <span class="sort-label">
                                    {{ 'table_head_kelt' | translate }}
                                </span>
                                <span class="sort-icon">
                                </span>
                            </span>
                        </th>
                        <th class="min-w-[180px]">
                            <span class="sort">
                                <span class="sort-label">
                                    {{ 'table_head_partner' | translate }}
                                </span>
                            </span>
                        </th>
                        <th class="min-w-[180px]">
                            <span class="sort">
                                <span class="sort-label">
                                    {{ 'table_head_kuldo_nev' | translate }}
                                </span>
                            </span>
                        </th>
                        <th class="min-w-[180px]">
                            <span class="sort">
                                <span class="sort-label">
                                    {{ 'table_head_cimzett_nev' | translate }}
                                </span>
                            </span>
                        </th>
                    </tr>
                </thead>            

                <app-loading-progress [style.display]="((componentListLoaded$ | async) === false || (componentListLoaded$ | async) === null) ? '' : 'none'"></app-loading-progress>
               
                <tbody>         
                @for(item of componentList | async; track $index) {   
                    <tr class="text-xs">
                        <td>
                            <a href="javascript:;" class="btn btn-link btn-sm" [routerLink]="['/offers/details', item.getKod()]"
                                [innerHTML]="item.getNormalizedOfferCode()">
                            </a>
                        </td>
                        <td>
                            <a href="javascript:;" class="btn btn-link btn-sm" [routerLink]="['/offers/details', item.getKod()]" 
                                [innerHTML]="item.getNormalizedOfferTitle()">
                            </a>
                        </td>
                        <td>
                            @if((item.getVerziok() - 1) > 0) {
                                <span class="badge badge-sm badge-outline badge-primary">
                                    +{{ (item.getVerziok() - 1) }} verzió
                                </span>
                            }
                        </td>
                        <td>
                            {{ item.getKelt() | dateformat: { pattern: 'Y-m-d'} }}
                        </td>
                        <td>
                            {{ item.getPartnerNev() }}
                        </td>
                        <td>
                            {{ item.getKuldoNev() }}
                        </td>
                        <td>
                            {{ item.getCimzettNev() }}
                        </td>
                    </tr> 
                }
                </tbody>
            </table>

        </div>
        <div class="card-footer justify-center md:justify-between flex-col md:flex-row gap-5 text-gray-600 text-2sm font-medium">
            
            <app-core-table-paginator 
                [table]="this.table" 
                [coreResponsePagination]="componentCollectionMetadata" 
                (paginationEvent)="tablePagination($event)"
                >
            </app-core-table-paginator>

        </div>
    </div>
</div>
<!-- end of datatable -->